import { ReactEditor } from 'slate-react'

/** @todo do we need this now? */
export function isReactEditor(value: unknown): value is ReactEditor {
  return value !== null && typeof value === 'object' && 'findPath' in value
}
